import { InfoIcon, Modal, Typography, WarningIcon2 } from '@orijinworks/frontend-commons';
import React from 'react';
import { DeleteModalStyles } from './DeleteModal.styles';

/**
 * Header icon per confirmation status. Built on render so only the status in use is created:
 * `danger` warns about a destructive action, `info` confirms a reversible one.
 */
const STATUS_ICONS = {
    danger: () => <WarningIcon2 sx={{ color: 'white' }} />,
    info: () => <InfoIcon sx={{ color: 'white' }} />,
};

const DeleteModal = React.memo(({ title, description, open, onClose, onContinue, modalRef, status = 'danger' }) => {
    const modalStatus = STATUS_ICONS[status] ? status : 'danger';

    return (

        <Modal
            ref={modalRef}
            actionBtnText='Confirm'
            cancelBtnText='Cancel'
            onContinue={onContinue}
            onClose={onClose}
            Icon={STATUS_ICONS[modalStatus]()}
            modalType={{ type: 'confirmation', status: modalStatus, size: 'medium' }}
            labelledBy={title}
            describedBy={description}
            styles={{
                mainWrapperStyles: { height: 'auto' },
            }}
            mainModalStyles={DeleteModalStyles}
            open={open}
        >
            <Typography variant="h6">{title}</Typography>
            <Typography 
            styles={{
                color: 'blue'
            }}
            variant="body1">{description}</Typography>
        </Modal>
    );
});

export default DeleteModal;